<template>
  <div>
      
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-light">
          <span>供货商配送汇总</span>
        </div>
      </el-col>
      <el-col :span="24">
        <el-form :inline="true" :model="queryParam" class="demo-form-inline" size="mini">
          
          <el-form-item label="ISBN">
            <el-input v-model="queryParam.productSn" placeholder="ISBN"></el-input>
          </el-form-item>
          <el-form-item label="书名">
            <el-input v-model="queryParam.productName" placeholder="书名（模糊）"></el-input>
          </el-form-item>
          <!-- <el-form-item label="库位">
            <el-input v-model="queryParam.position" placeholder="库位"></el-input>
          </el-form-item> -->
          <el-form-item label="订单时间">
            <el-col :span="11" style="margin-top: 0">
              <el-date-picker type="date" placeholder="选择开始日期" v-model="queryParam.createTime_begin" style="width: 100%;" value-format="yyyy-MM-dd 00:00:00"></el-date-picker>
            </el-col>
            <el-col class="line" style="text-align:center; margin-top: 0" :span="2">-</el-col>
            <el-col :span="11" style="margin-top: 0">
              <el-date-picker type="date" placeholder="选择结束日期" v-model="queryParam.createTime_end" style="width: 100%;" value-format="yyyy-MM-dd 23:59:59"></el-date-picker>
            </el-col>
          </el-form-item>
          <!-- <el-form-item label="支付时间 ：">
            <el-col :span="11">
              <el-date-picker type="date" placeholder="选择日期" v-model="queryParam.payTime_begin" style="width: 100%;" value-format="yyyy-MM-dd 00:00:00"></el-date-picker>
            </el-col>
            <el-col class="line" style="text-align:center;" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker type="date" placeholder="选择日期" v-model="queryParam.payTime_end" style="width: 100%;" value-format="yyyy-MM-dd 23:59:59"></el-date-picker>
            </el-col>
          </el-form-item> -->
          <el-button size="mini" type="primary" icon="el-icon-search" @click="list(1)">查询</el-button>
          <el-button size="mini" icon="el-icon-download" @click="exportFun()">导出</el-button>

      </el-form>
      </el-col>
    </el-row>
    <el-table :data="tableData" stripe border style="width: 100%" v-loading="loading" element-loading-text="正在查找中，请稍后。。。">
      <el-table-column prop="productSn" label="ISBN" width="150"/>
      <el-table-column prop="productName" label="图书名称"/>
      <el-table-column prop="position" label="库位" width="80" />
      <el-table-column prop="productNumber" label="购买数量" width="80"/>
      <!-- <el-table-column prop="productAssigned" label="配送数量" width="80"/> -->
      <el-table-column prop="marketPrice" label="定价(元)" width="80"/>
      <el-table-column prop="marketTwoPrice" label="码洋" width="90">
        <template slot-scope="scope">
          {{ scope.row.marketPrice * scope.row.productNumber }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="discount" label="折扣" width="60"/> -->
      <el-table-column prop="costDiscount" label="进货折扣" width="80"/>
      <!-- <el-table-column prop="shopPrice" label="实洋" width="90"/> -->
      <el-table-column prop="costPrice" label="进货折扣实洋(元)" width="140">
        <template slot-scope="scope">
          {{ scope.row.marketPrice * scope.row.productNumber * scope.row.costDiscount }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="订单时间" width="170"/>
    </el-table>
    <el-row align="bottom">
      <el-col :span="16">
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" layout="prev,pager,next" :total="pageTotal">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getAction, downFile } from "../../api/index";
import { mapGetters } from "vuex";
export default {
  name: "shipAddress",
  data() {
    return {
      tableData: [],
      textarea: "",
      isdefault: false,
      url: {
        list: "/provider/deliverySummaryPage",
        downloadFile: "/provider/deliverySummaryExport",
      },
      queryParam:{
        productSn: '',
        createTime_begin: '',
        createTime_end: '',
        payTime_begin: '',
        payTime_end: '',
      },
      currentPage: 1, // 当前页码
      pagesize: 10, // 每页显示的行数
      pageTotal: 0,
      loading: false,
    };
  },
  mounted() {},
  computed: {
    ...mapGetters(["isNaName"]),
  },
  created() {
    this.queryParam.createTime_begin = this.$moment().format("YYYY-MM-DD") + ' 00:00:00'
    this.queryParam.createTime_end = this.$moment().format("YYYY-MM-DD") + ' 23:59:59'
    this.list(1);
  },
  methods: {
    list(page) {
      const that = this
      that.loading = true;
      that.queryParam.whId = this.$store.state.userInfo.id
      that.queryParam.pageNo = page
      that.queryParam.pageSize = this.pagesize
      
      getAction(that.url.list, that.queryParam).then((res) => {
        that.loading = false;
        if (res.data.success) {
          this.tableData = res.data.result.records;
          this.pageTotal = res.data.result.total;
        }
      });
    },
    exportFun() { 
      const that = this
      // that.loading = true;
      that.queryParam.whId = this.$store.state.userInfo.id

      downFile(this.url.downloadFile, that.queryParam).then((res) => {
        try {
          let fileName = this.$options.filters.dateFormat(new Date(), '预配送表-YYYYMMDDHHmmss') + '.xls';
          let url = window.URL.createObjectURL(new Blob([res.data]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove()
        } catch (e) {
          console.log(e)
        }
      }).finally(() => {
      });
    },

    // 页面切换方法
    handleCurrentChange(val) {
      this.list(val);
      this.currentPage = val;
    },
  },
};
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
  margin-top: 1%;
  font-size: 14px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.bg-purple-light {
  line-height: 36px;
  display: flex;
  justify-content: space-between;
}
.el-cascader {
  display: block;
}
</style>
